import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import { apiGet,apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import obj from "../Utils/helpers";
import Slider from "react-slick";
import Aboutus from "../components/staticContent/Aboutus";
import GeneralTerms from "../components/staticContent/GeneralTerms";
import Kyc from "../components/staticContent/Kyc";
import PrivacyPolicy from "../components/staticContent/PrivacyPolicy";
import RulesRegulation from "../components/staticContent/RulesRegulation";
import ResponsibleGaming from "../components/staticContent/ResponsibleGaming";
import { LazyLoadImage } from 'react-lazy-load-image-component';
function Home() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  const [inplayCountData, setInplayCountData] = useState({});

  const navigate = useNavigate();
  let {
    isLoged,
    setIsLoged,
    setCasinoModel,
    setCasinoObj,
    launchCasino,
    user,
    open,
    setOpen,
    content,
    slug,
    setSlug,
    handleContentToggle,
    launchGis,
    dolaunchCasinoNew
  } = useContext(AuthProvider);
  const inPlayCount = async () => {
    const { status, data: response_users } = await apiGet(apiPath.inPlayCount);
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setInplayCountData(response_users.results);
        }
      }
    }
  };
  const [linkData, setLinkData] = useState([]);
  const getSetting = async (event) => {
    try {
      const { status, data: response_users } = await apiGet(apiPath.getSetting);
      if (status === 200) {
        if (response_users.success) {
          setLinkData(response_users.results);
        }
      }
    } catch (err) {}
  };

  const [bannerData, setBannerData] = useState([]);
  const getData = async () => {
    const { status, data } = await apiPost(apiPath.getBanner, {
      type: "home_top",
    });
    if (status == 200) {
      if (data?.success) {
        setBannerData(data?.results?.banners);
        
      }
    }
  };
 

  useEffect(() => {
    inPlayCount();
    getSetting();
    getData();
  }, []);
  return (
    <div>
      <div className="promo-viewport">
      <Slider {...settings}>
        {bannerData?.length > 0 &&
          bannerData?.map((item) => {
            return (
          <div>
            <LazyLoadImage
             src={process.env.REACT_APP_API_BASE_URL + item?.banner_path}
              
              style={{ width: "100%" }}
              alt=""
            />
          </div>
        );
        })}
        
        </Slider>
      </div>
      <div id="page">
        <div className="mian-wrap">
          <div className="gamehall">
            <a href="#" neua="InPlay Banner">
              <dl className="entrance-title">
                <dt>Sports</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <dl
                id="onLiveBoard"
                onClick={() => navigate("/inplay")}
                className="on_live"
              >
                <dt>
                  <p className="live_icon">
                    <span></span> LIVE
                  </p>
                </dt>

                <dd id="onLiveCount_CRICKET">
                  <p>Cricket</p>
                  <span id="count">
                    {inplayCountData?.cricketInplayCount || 0}
                  </span>
                </dd>

                <dd id="onLiveCount_SOCCER">
                  <p>Soccer</p>
                  <span id="count">
                    {inplayCountData?.soccerInplayCount || 0}
                  </span>
                </dd>

                {/* <dd id="onLiveCount_E_SOCCER">
                  <p>E-Soccer</p>
                  <span id="count">
                    {inplayCountData?.soccerInplayCount || 0}
                  </span>
                </dd> */}

                <dd id="onLiveCount_TENNIS">
                  <p>Tennis</p>
                  <span id="count">
                    {inplayCountData?.tennisInplayCount || 0}
                  </span>
                </dd>
              </dl>
              <Link to="/inplay">
               <LazyLoadImage
                  src={
                    process.env.REACT_APP_MOBILE_URL +
                    "/assets/images/home/banner_sports.webp"
                  }
                  alt=""
                />
              </Link>
            </a>
            {/* <a
              className="entrance"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "SABA",
                    gameType: "VIRTUAL",
                    casinoType: "SABA-VIRTUAL-001",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Saba Sports</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/spotsaba.webp"
                }
                alt=""
              />
            </a> */}
            <a
              className="entrance"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  //
                  launchCasino({
                    platForm: "HORSEBOOK",
                    gameType: "LIVE",
                    casinoType: "HRB-LIVE-001",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Horse Book</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/horse.webp"
                }
                alt=""
              />
            </a>
           
        
            {/* <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "PP",
                    gameType: "LIVE",
                    casinoType: "PP-LIVE-042",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Dragon Tiger</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilidt2.webp"
                }
                alt=""
              />
            </a> */}
           
            {/* <a
              className=""
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-060",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Ludo</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/ludo.webp"
                }
                alt=""
              />
            </a> */}
     
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "SEXYBCRT",
                    gameType: "LIVE",
                    casinoType: "MX-LIVE-002",
                  });
                } else {
                  navigate("/Mlogin");
                }
              }}
              neua="AEIndia Banner"
            >
              <dl className="entrance-title">
                <dt>AE Sexy</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/aesexy.webp"
                }
                alt=""
              />
            </a>

            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "1",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>Live Casino</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/banner_casino-half.png"
                }
                alt=""
              />
            </a>
            {/* <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "RT",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Red Tiger</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL + "/assets/images/home/redtigergaming.webp"
                }
                alt=""
                height="115px"
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "JDB",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Minesweeper Banner"
            >
              <dl className="entrance-title">
                <dt>JDB Gaming</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jdbgaming.webp"
                }
                alt=""
              />
            </a>

            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "FC",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>FC Gaming</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL + "/assets/images/home/fachaigaming.webp"
                }
                alt=""
               
              />
            </a> <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "YL",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>Yl Gaming</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/ylgaming.webp"
                }
                alt=""
              />
            </a> */}



<a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "PG",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>VENUS</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/venus-casino.webp"
                }
                alt=""
              />
            </a>
           
            {/* <a
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "SPADE",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              className="entrance-half"
              href="javascript:void(0)"
              neua="7Mojos Banner"
            >
              <dl className="entrance-title">
                <dt>Super Spade</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/superspade.webp"
                }
                alt=""
                height="150px"
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "BG",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Bet Games</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL + "/assets/images/home/betgames.webp"
                }
                alt=""
              
              />
            </a> */}
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "PP",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Pragmatic Play</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/pragmatic.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "NETENT",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Casino Banner"
            >
              <dl className="entrance-title">
                <dt>NETENT</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/netent.webp"
                }
                alt=""
              />
            </a>

             <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-036",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
              neua="Sicbo Banner"
            >
              <dl className="entrance-title">
                <dt>Coin Toss</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/32.webp"
                }
                alt=""
              />
            </a> 
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-021",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Number Matka</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/21.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "JDB",
                    gameType: "SLOT",
                    casinoType: "JDB-SLOT-041",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Lucky 777</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/777.jpeg"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "SPRIBE",
                    gameType: "EGAME",
                    casinoType: "SPRIBE-EGAME-001",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="AEIndia Banner"
            >
              <dl className="entrance-title">
                <dt>Aviator</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/aviator.jpeg"
                }
                alt=""
              />
            </a> 
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "HOTROAD",
                    gameType: "",
                    casinoType: "",
                    
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="AEIndia Banner"
            >
              <dl className="entrance-title">
                <dt>Ezugi</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/ezugi.jpeg"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "EVOLUTION",
                    gameType: "LIVE",
                    casinoType: "EVOLUTION-LIVE-006",
                    isLobbyTrue: true,
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="AEIndia Banner"
            >
              <dl className="entrance-title">
                <dt>Evolution</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
              <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/banner_evo-half.webp"
                }
                alt=""
              />
            </a>
            {/* <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-043",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
              neua="7Up7Down Banner"
            >
              <dl className="entrance-title">
                <dt>Bonus Dice</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/dice.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-047",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
              neua="KingMaker Banner"
            >
              <dl className="entrance-title">
                <dt>Heist</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/heist.webp"
                }
                alt=""
              />
            </a>

            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-049",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
              neua="KingMaker Banner"
            >
              <dl className="entrance-title">
                <dt>5 card Poker</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/5cardpoker.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-050",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
              neua="KingMaker Banner"
            >
              <dl className="entrance-title">
                <dt>Color game</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/color-games.webp"
                }
                alt=""
              />
            </a> */}
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-028",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>7 Up 7 Down</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/15.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-015",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Sicbo</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/banner-sicbo-half.webp"
                }
                alt=""
              />
            </a>

            
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-032",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="Rummy Banner"
            >
              <dl className="entrance-title">
                <dt>Andar Bahar</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/25.webp"
                }
                alt=""
              />
            </a>
            {/* <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-039",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="32Cards Banner"
            >
              <dl className="entrance-title">
                <dt>32 Cards</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/32cards.webp"
                }
                alt=""
              />
            </a> */}
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-038",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Blackjack</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/blackjack.webp"
                }
                alt=""
              />
            </a>
            
              <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "TABLE",
                    casinoType: "KM-TABLE-039",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="32Cards Banner"
            >
              <dl className="entrance-title">
                <dt>Minesweeper</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/mine.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-016",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>TeenPatti 20-20</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jiliteenpatti.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-005",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>NumberKing</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilinumberking.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-007",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Big small</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilibigsmall.webp"
                }
                alt=""
              />
            </a>
           
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-010",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Teen Patti Joker</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilitpjoker.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-011",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>7up7Down</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/7updown-jili.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              id="pokerLoginBtn"
              neua="Bpoker Banner"
              onClick={() => {
                if (!isEmpty(user)) {
                  launchCasino({
                    platForm: "JILI",
                    gameType: "SLOT",
                    casinoType: "JILI-SLOT-034",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
            >
              <dl className="entrance-title">
                <dt>Dragon Tiger</dt>
                <dd>
                  <span>Play Now</span>
                </dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jili-dragon-tiger.webp"
                }
                alt=""
              />
            </a>
           
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-009",
                  });
                } else {
                  navigate("/login");
                }
              }}
              neua="ROYAL Banner"
            >
              <dl className="entrance-title">
                <dt>Callbreak Quick</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilitpjoker.webp"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-017",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Sicbo</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilisicbo.webp"
                }
                alt=""
              />
            </a>

            <a
              className="entrance-half"
              href="javascript:void(0)"
              onClick={() => {
                if (!isEmpty(user)) {
                  
                  launchCasino({
                    platForm: "JILI",
                    gameType: "TABLE",
                    casinoType: "JILI-TABLE-014",
                  });
                } else {
                  navigate("/login");
                }
              }}
            >
              <dl className="entrance-title">
                <dt>Baccarat</dt>
                <dd><span>Play Now</span></dd>
              </dl>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jilibaccrat.webp"
                }
                alt=""
              />
            </a>

           <a
              className="entrance-half"
              id="pokerLoginBtn"
              neua="Bpoker Banner"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "KINGMAKER",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
            >
              <dl className="entrance-title">
                <dt>Kingmaker</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <LazyLoadImage
              
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/kingmakerlobby.jpeg"
                }
                alt=""
              />
            </a>
            <a
              className="entrance-half"
              id="pokerLoginBtn"
              neua="Bpoker Banner"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "JILI",
                    gameType: "",
                    casinoType: "",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
            >
              <dl className="entrance-title">
                <dt>JILI</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <LazyLoadImage
             
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/jililobby.jpeg"
                }
                alt=""
              />
            </a>

           {/*  */}

            <a
                className="entrance-half"
              id="pokerLoginBtn"
              neua="Bpoker Banner"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "EVOLUTION",
                    gameType: "LIVE",
                    casinoType: "EVOLUTION-LIVE-006",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
            >
              <dl className="entrance-title">
                <dt>Crazy Time</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <LazyLoadImage
              style={{height:`36vw`}}
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/evo-crazy-time.webp"
                }
                alt=""
              />
            </a>

            <a
              
              id="pokerLoginBtn"
              neua="Bpoker Banner"
              onClick={() => {
                if (!isEmpty(user)) {

                  launchCasino({
                    platForm: "SV388",
                    gameType: "LIVE",
                    casinoType: "SV-LIVE-001",
                  });
                } else {
                  navigate("/login");
                }
              }}
              href="javascript:void(0)"
            >
              <dl className="entrance-title">
                <dt>Cock fight</dt>
                <dd><span>Play Now</span></dd>
              </dl>
              <LazyLoadImage
              style={{height:`36vw`}}
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/sv388.jpeg"
                }
                alt=""
              />
            </a>
           
            
            


           
            {/* new-phase */}
          </div>

          <div id="supportWrap" class="support-wrap">
            <div class="support-service">
             {/* {!isEmpty(linkData) && linkData?.whatsappContent &&  */}
              <a id="support-whatsapp"  onClick={() => setOpen("tab1")} className={open=="tab1" ? "support-whatsapp open" : "support-whatsapp"}>
               <LazyLoadImage src={process.env.REACT_APP_MOBILE_URL + "/assets/images/home/transparent.gif"} alt="whatsApp" title="WhatsApp" />
              </a> 
            {/* }  */}
              {/* {!isEmpty(linkData) && linkData?.facebookContent && */}
              {/* <a id="support-fb" onClick={() => setOpen("tab2")} className={open=="tab2"  ? "support-fb open" : "support-fb"}> 
             <LazyLoadImage src={process.env.REACT_APP_MOBILE_URL +"/assets/images/home/transparent.gif"} alt="facebook" title="facebook"/> 
              </a> */}
              {/* } */}
                {/* {!isEmpty(linkData) && linkData?.emailContent && */}
              {/* <a id="support-mail" onClick={() => setOpen("tab3")} className={open=="tab3"  ? "support-mail open" : "support-mail"}>
               <LazyLoadImage src={ process.env.REACT_APP_MOBILE_URL +"/assets/images/home/transparent.gif"} alt="Email" title="Email"/>
                </a> */}
            {/* }    */}
            {/* {!isEmpty(linkData) && linkData?.telegramContent && */}
              <a id="support-telegram" onClick={() => setOpen("tab4")} className={open=="tab4"  ? "support-telegram open" : "support-telegram"}>
               <LazyLoadImage src={ process.env.REACT_APP_MOBILE_URL +"/assets/images/home/transparent.gif"}  alt="Telegram" title="Telegram"/>
              </a>
            {/* } */}
             {/* {!isEmpty(linkData) && linkData?.skypeContent && */}
              {/* <a id="support-skype" onClick={() => setOpen("tab5")} className={open=="tab5"  ? "support-skype open" : "support-skype"}>
               <LazyLoadImage src={process.env.REACT_APP_MOBILE_URL +"/assets/images/home/transparent.gif" } alt="Skype" title="Skype"/>
              </a> */}
             {/* } */}
               {/* {!isEmpty(linkData) && linkData?.instagramContent &&
              <a id="support-instagram" onClick={() => setOpen("tab6")} className={open=="tab6"  ? "support-ig open" : "support-ig"}> 
             <LazyLoadImage src={process.env.REACT_APP_MOBILE_URL +"/assets/images/home/transparent.gif"} alt="Instagram" title="Instagram" />
              </a>
            } */}
            </div>
            <div class="support-info">
              {
                open=="tab1" && (
                  <div id="supportDetail_whatsapp" className={open=="tab1"  ? "support-detail open" : "support-telegram"}>
                    <a href={!isEmpty(linkData) && linkData?.whatsappContent ? "https://wa.me/"+linkData?.whatsappContent:"#"}>
                      <span>{!isEmpty(linkData) && linkData?.whatsappContent ? linkData?.whatsappContent:""}</span>
                    </a>
                  </div>
                )
              }
              {
                open=="tab2" && (
                  <div id="supportDetail_fb" className={open=="tab2"  ? "support-detail open" : "support-telegram"}>
                    <a href={!isEmpty(linkData) && linkData?.facebookContent ? linkData?.facebookContent:"#"}>
                      <span>{!isEmpty(linkData) && linkData?.facebookContent ? linkData?.facebookContent:"#"}</span>
                    </a>
                  </div>
                )
              }{
                open=="tab3" && (
                  <div id="supportDetail_email" className={open=="tab3"  ? "support-detail open" : "support-telegram"}>
                  <a href={!isEmpty(linkData) && linkData?.emailContent ? "emailto:"+linkData?.emailContent:"#"}>
                    <span>{!isEmpty(linkData) && linkData?.emailContent ? linkData?.emailContent:"#"}</span>
                  </a>
                </div>
                )
              }{
                open=="tab4" && (
                  <div id="supportDetail_telegram" className={open=="tab4"  ? "support-detail open" : "support-telegram"}>
                  <a href={!isEmpty(linkData) && linkData?.telegramContent ? "https://t.me/"+linkData?.telegramContent:"info@betbuz365.live"}>
                    <span>{!isEmpty(linkData) && linkData?.telegramContent ? linkData?.telegramContent:"info@betbuz365.live"}</span>
                  </a>
                  
                </div>
                )
              }{
                open=="tab5" && (
                  <div id="supportDetail_skype" className={open=="tab15"  ? "support-detail open" : "support-telegram"}>
                    <a href={!isEmpty(linkData) && linkData?.skypeContent ? "skype:"+linkData?.skypeContent:"#"}>
                      <span>{!isEmpty(linkData) && linkData?.skypeContent ? linkData?.skypeContent:"#"}</span>
                    </a>
                  </div>
                )
              }{
                open=="tab6" && (
                  <div id="supportDetail_instagram" className={open=="tab6"  ? "support-detail open" : "support-telegram"}>
                  <a class="ui-link" href={!isEmpty(linkData) && linkData?.instagramContent ? linkData?.instagramContent:"#"}>
                    <span>{!isEmpty(linkData) && linkData?.instagramContent ? linkData?.instagramContent:"#"}</span>
                  </a>
                </div>
                )
              }
             </div>
            </div>

          <ul className="policy-link">
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("about");
                }}
              >
                About us
              </Link>
            </li>

            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("term");
                }}
              >
                Terms and Conditions
              </Link>
            </li>

            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("kyc");
                }}
              >
                KYC
              </Link>
            </li>

            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("privacy");
                }}
              >
                Privacy Policy
              </Link>
            </li>

            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("rules");
                }}
              >
                Rules and Regulations
              </Link>
            </li>

            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("responsible");
                }}
              >
                Responsible Gaming
              </Link>
            </li>
            {/* <li>
              <a href="#">About Us</a>
            </li>
            <li>
              <a href="#">Self-Exclusion Policy</a>
            </li>
            <li>
              <a href="#">Underage Policy</a>
            </li> */}
          </ul>

          {/* static-content */}

          {content && (
            <div className="frame-wrap">
              <div className="news-wrap news-wrap-frame">
                {slug === "about" && <Aboutus />}
                {slug === "term" && <GeneralTerms />}
                {slug === "kyc" && <Kyc />}
                {slug === "privacy" && <PrivacyPolicy />}
                {slug === "rules" && <RulesRegulation />}
                {slug === "responsible" && <ResponsibleGaming />}

                <footer>
                  <Link
                    to="#"
                    className="btn-send"
                    onClick={() => {
                      handleContentToggle();
                      setSlug("");
                    }}
                  >
                    CLOSE
                  </Link>
                </footer>
              </div>
            </div>
          )}

          {/* static-content */}

          <div className="extra-wrap">
            <div
              id="powerWrap"
              className="power-wrap-b"
              style={{ display: "block" }}
            >
              <span>Powered by</span>
             <LazyLoadImage
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
              />
            </div>

            <div className="appdl-link-android" style={{ display: "block" }}>
              <a href="#">
               <LazyLoadImage
                  src={
                    process.env.REACT_APP_MOBILE_URL +
                    "/assets/images/home/btn-appdl-android.png"
                  }
                  alt=""
                />
              </a>
              <p>v1.11 - 2022-03-23 - 3.1MB</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
